import draftToHtml from "draftjs-to-html";

export const converDraftJsDataToHtml = (draftJsDataString) => {
  const parsedData = JSON.parse(draftJsDataString);
  const htmlMarkup = draftToHtml(parsedData);
  return htmlMarkup;
};
